var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiHospitalGroupReportIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#haidiHospitalGroupReportIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h8v8H0V0Zm5 2H3v1H2v2h1v1h2V5h1V3H5V2Zm4 2h3v8H4V9h5V4Z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "haidiHospitalGroupReportIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h12v12H0z"
})))));
export default SvgHaidiHospitalGroupReportIcon;